import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-reports',
  templateUrl: './order-reports.component.html',
  styleUrls: ['./order-reports.component.scss']
})
export class OrderReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
